import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EmployerPrimaryContactFormGroup } from '../../../../../forms/employer-primary-contact-form-group';
import { EmployerRecordPrimaryContactFormGroup } from '../../../../../forms/employer-record-primary-contact-form-group';
import { PhoneDropdownItem } from '../../../../../models/shared/phone-dropdown-item';

@Component({
  selector: 'app-employer-primary-contact-form-grid',
  templateUrl: './employer-primary-contact-form-grid.component.html',
  styleUrls: ['./employer-primary-contact-form-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerPrimaryContactFormGridComponent {
  @Input({ required: true }) form!: EmployerPrimaryContactFormGroup | EmployerRecordPrimaryContactFormGroup;
  @Input() formSubmitted: boolean = false;
  @Input() countryCodeDropdowns: PhoneDropdownItem[] = [];
  @Input() controlIdPrefix: string = '';

  public customErrorMessages = {
    firstName: {
      required: $localize`First Name required`
    },
    lastName: {
      required: $localize`Last Name required`
    },
    jobTitle: {
      required: $localize`Job Title required`
    },
    phoneNumber: {
      required: $localize`Phone Number required`
    },
    email: {
      required: $localize`Email required`
    }
  };
}
